import React, { useState, useEffect } from 'react';
import { User } from '../../../types';
import '../styles/AdminPanel.css';

interface StudentInfoModalProps {
  student: User;
  isOpen: boolean;
  onClose: () => void;
  onStudentUpdated: (studentData: Partial<User>) => void;
}

const StudentInfoModal: React.FC<StudentInfoModalProps> = ({ student, isOpen, onClose, onStudentUpdated }) => {
  const [studentData, setStudentData] = useState<Partial<User>>({});

  useEffect(() => {
    if (student) {
      setStudentData({
        displayName: student.displayName || '',
        parentEmail: student.parentEmail || '',
        museCash: student.museCash || 0,
      });
    }
  }, [student]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setStudentData(prev => ({ ...prev, [name]: value }));
  };

  const handleSave = () => {
    onStudentUpdated(studentData);
  };

  if (!isOpen) return null;

  return (
    <div className="confirm-delete-modal-overlay" onClick={onClose}>
      <div className="confirm-delete-modal" onClick={e => e.stopPropagation()}>
        <h3>Edit Student: {student.displayName}</h3>
        <div className="admin-form">
          <div className="form-group">
            <label>Display Name</label>
            <input
              type="text"
              name="displayName"
              value={studentData.displayName || ''}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>Parent Email</label>
            <input
              type="email"
              name="parentEmail"
              value={studentData.parentEmail || ''}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>Muse Cash</label>
            <input
              type="number"
              name="museCash"
              value={studentData.museCash || 0}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="confirm-delete-actions">
          <button onClick={onClose} className="cancel-btn">
            Cancel
          </button>
          <button onClick={handleSave} className="save-btn">
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
};

export default StudentInfoModal;
